module.exports = __webpack_public_path__ + "img/fashion_76.4933281f.jpg";